<template>
  <div v-if="titreRecette"
    class="section is-paddingless"
    :class="{'section-details': !isBrouillon }">
    <div class="entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ titleRecette }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <qd-button @click="$router.go(-1)"
                class="button btn-modal-annuler">
                {{ $t('general.button.cancel') }}
              </qd-button>
              <qd-button
                @click="isBrouillon ? saveTitreRecette() : saveTitreRecetteAlreadyPayeOrSave()"
                class="button is-addOrEdit mgl-10px">
                {{ !isBrouillon ? $t('general.button.sauvegarder')
                  : $t('editionTitreRecette.actions.save')}}
              </qd-button>
              <piece-jointe-button
                class="mgr-2"
                :perm="constantes.TITRE_RECETTE.maj">
              </piece-jointe-button>
            </div>
          </div>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li :class="{'is-active': active === 'factureInformation'}" v-if="isBrouillon"
            @click="active = 'factureInformation'">
            {{ $t('editionTitreRecette.onglet.titreRecette') }}
          </li>
          <li :class="{'is-active': active === 'depenseBailleur'}" v-else
            @click="active = 'depenseBailleur'">
            {{ $t('editionTitreRecette.onglet.titreRecette') }}
          </li>
          <li :class="{'is-active': active === 'echeancierPaiement'}"
            @click="active = 'echeancierPaiement'">
            {{ $t('editionTitreRecette.onglet.echeancierPaiement') }}
          </li>
          <li @click="active = 'editionLignesCommandes'"
            v-if="!isBrouillon"
            :class="{'is-active': active === 'editionLignesCommandes'}">
            {{ $t('editionTitreRecette.onglet.editionLignesCommandes')}}
          </li>
          <li
            v-if="!isAvoir"
            :class="{'is-active': active === 'rapprochement'}"
            @click="active = 'rapprochement'">
            <b-field>
              <div class="mgv-auto mgr-5px" :class="getColorStatusRapprochement"></div>
              <span>{{ $t('detailTitreRecette.onglet.rapprochement') }}</span>
            </b-field>
          </li>
        </ul>
      </div>
    </div>

    <error-msg-component :messages="messages"
      :error="error"
      :title="'general.problemOccurred'"
      :withEmplyFields="true"
      :messagesChampsVide="messagesChampsVide"
      :champsVide="champsVide"
      @close="error = $event"/>

    <component v-if="titreRecette"
      :is="active"
      :facture="titreRecette"
      :factureDetail="titreRecette"
      :id="titreRecette.id"
      :devisCommande="titreRecette"
      :datePaiementBase="datePaiement"
      :detailDevisCommande="titreRecetteDetail"
      :dcf="titreRecette"
      :query="query"
      :moduleType="constantes.MODULE_TLPE"
      :sens="constantes.SENS_ACHAT"
      :commandeAchatARapprocher="commandeAchatARapprocher"
      :isAvoirLibre="isAvoirLibre"
      @refreshCommandeAchat="updateCommandeArapprocher"
      @tiersUpdated="resetCommandeArapprocher"
      @updateDatePaiement="updateDatePaiement"/>

    <piece-jointe v-if="active === 'factureInformation'"
      :checkPermissions="true"
      class="mgt-20px"/>
    <b-modal v-model="popUpPrevention"
      has-modal-card
      class="modal">
      <pop-up-prevention :messHeader="$t('editionTitreRecette.popUpPrevention.title')"
        :messDescription="$t('editionTitreRecette.popUpPrevention.subTitle')"
        :validate="$t('general.button.next')"
        :cancel="$t('general.button.cancel')"
        @yes="continuWithLigneWithoutDate"
        @no="popUpPrevention = false"/>
    </b-modal>
    <b-modal v-model="popUpPreventionFirstEcheance"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :messHeader="$t('editionTitreRecette.popUpPrevention.titleWarningRapprochement')"
        :messDescription="$t('editionTitreRecette.popUpPrevention.subTitle')"
        :validate="$t('general.button.next')"
        :cancel="$t('general.button.cancel')"
        @yes="saveAnywayAndSaveTitreRecette"
        @no="popUpPreventionFirstEcheance = false"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import breadcrumb from '@/components/general/breadcrumb';
import { TITRE_RECETTE } from '@/configuration/gabed/permissionsGabedConf';
import * as devisConf from '@/configuration/devisConf';
import {
  create,
  get,
  update,
  updateFactureEnregistrer,
} from '@/api/factureAchatARapprocher/index';
import preparationEnvoiBack from '@/services/devisCommandes/preparationEnvoiBack/preparationEnvoiBack';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/baux/factureAchatArapprocher/validation/translate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import echeancierPaiement from '@/components/factures/echeancierPaiement';
import gestionDateBase from '@/services/general/gestionDateBase';
import genererDevisCommande from '@/services/devisCommandes/genererDevisCommande';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';
import genererIntervenant from '@/services/devisCommandes/genererIntervenant';
import getInfoEcheancierPaiement from '@/services/echeancePaiement/getInformationEcheancierPaiement';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import { get as getTiers } from '@/api/tiers';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import factureInformation
  from '@/components/baux/factureAchatARapprocher/edition/factureAchatInformation/factureInformation';
import pieceJointe from '@/components/baux/contrat/componentEdition/pieceJointe';
import depenseBailleur from '@/components/factures/factureDetail';
import calculArrondi from '@/services/calcul/calculArrondi';
import editionLignesCommandes
  from '@/components/baux/factureAchatARapprocher/edition/produit/m_editionLignesCommandes';
import { getAllEcheancier } from '@/api/commandeAchat';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import formatIsoDate from '@/services/general/formatIsoDate';
import { SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE } from '@/configuration/facture/factureConf';
import echeancierGeneration from '@/services/facture/generationEcheancier';
import prepareFactureAchatAlreadyPayeOrSave from '@/services/baux/factureAchatArapprocher/prepareFactureAchatAlreadyPayeOrSave';
import { updateEcheancierPaiement } from '@/api/echeancierPaiement';
import validation from '@/services/baux/factureAchatArapprocher/validation/validationFactureAchat';
import rapprochement from '@/components/baux/factureAchatARapprocher/edition/rapprochement/rapprochement';
import * as typesfacture from '@/store/modules/facture-mutation-type';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import sortCommandeAchat from '@/services/baux/commandeAchat/sortCommandeAchat';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import {
  genererCritereRechercheRapprochementTlpe,
} from '@/services/baux/factureAchatArapprocher/rapprochement/genererCritereRechercheRapprochement';
import { initializeCommandeAchatRapprochement } from '@/services/achat/factures/factureAchatServices';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const factures = createNamespacedHelpers('facture');

export default {
  name: 'm_titreRecette',
  data() {
    return {
      active: null,
      titreRecette: null,
      titreRecetteDetail: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      constantes: {
        SENS_ACHAT: devisConf.SENS_ACHAT,
        TITRE_RECETTE,
        MODULE_TLPE,
      },
      query: genererCritereRechercheRapprochementTlpe(),
      continue: false,
      popUpPrevention: false,
      popUpPreventionFirstEcheance: false,
      datePaiement: null,
      commandeAchatARapprocher: [],
    };
  },
  components: {
    breadcrumb,
    factureInformation,
    pieceJointe,
    echeancierPaiement,
    errorMsgComponent,
    depenseBailleur,
    editionLignesCommandes,
    popUpPrevention,
    rapprochement,
    pieceJointeButton,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...factures.mapGetters({
      avoirACreer: 'avoirACreer',
    }),
    titleRecette() {
      if (this.isAvoir) {
        if (this.titreRecette.id) {
          return this.$t('editionTitreRecette.titleAvoirUpdate', { code: this.titreRecette.code });
        }
        return this.$t('editionTitreRecette.titleAvoirCreation');
      }
      if (this.titreRecette.id) {
        return this.$t('editionTitreRecette.titleUpdate', { code: this.titreRecette.code });
      }
      return this.$t('editionTitreRecette.titleCreation');
    },
    isAvoir() {
      return [SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE]
        .includes(this.titreRecette.sousType);
    },
    isAvoirLibre() {
      return this.isAvoir && this.titreRecette.referenceId === null;
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('editionTitreRecette.breadcrumb.listeTitreRecette'), route: { name: 'l.gabed.titre_recette' }, isActive: false },
        {
          title: this.$route.params.id ? this.breadcrumbUpdate
            : this.breadcrumbCreation,
          route: {},
          isActive: true,
        },
      ];
    },
    breadcrumbCreation() {
      return this.isAvoir
        ? this.$t('editionTitreRecette.breadcrumb.creationAvoir')
        : this.$t('editionTitreRecette.breadcrumb.creation');
    },
    breadcrumbUpdate() {
      return this.isAvoir
        ? this.$t('editionTitreRecette.breadcrumb.updateAvoir')
        : this.$t('editionTitreRecette.breadcrumb.update');
    },
    isBrouillon() {
      return this.titreRecette.etat === devisConf.ETAT_BROUILLON;
    },
    checkDateLignes() {
      if (this.continue) return false;
      return (this.titreRecette.lignesCommande.some((ligne) => {
        return (!ligne.dateDebut || !ligne.dateFin)
          || (moment(ligne.dateDebut).isSame(moment(ligne.dateFin)));
      }));
    },
    montantAvoir() {
      const t = this.titreRecette.avoirsAffectes
        .map(a => Math.abs(a.montantHt))
        .reduce((partialSum, a) => partialSum + a, 0);
      return t;
    },
    montantARapprocher() {
      return this.titreRecette.montantHt - this.montantAvoir;
    },
    getColorStatusRapprochement() {
      if (this.commandeAchatARapprocher.length === 0) return 'round-circle-danger';
      const montantAffecter = this.commandeAchatARapprocher
        .map((echeance) => echeance.montantAffecter)
        .reduce((a, b) => calculArrondi(a + b));
      if (montantAffecter === this.montantARapprocher && this.montantARapprocher > 0) {
        return 'round-circle-success';
      }
      if (montantAffecter < this.montantARapprocher || this.montantARapprocher === 0) {
        return 'round-circle-warning';
      }
      return 'round-circle-danger';
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...factures.mapMutations({
      setAvoirACreer: typesfacture.SET_AVOIR_A_CREER,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    updateDatePaiement(newDatePaiement) {
      this.datePaiement = newDatePaiement;
      if (this.titreRecette.echeancierPaiement.length !== 1) return;
      this.titreRecette.echeancierPaiement[0].dateEcheance = newDatePaiement;
    },
    async saveTitreRecetteAlreadyPayeOrSave() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const donneeForBack = prepareFactureAchatAlreadyPayeOrSave(
          this.titreRecette,
          this.getCommandeAchatARapprocher(),
        );
        await updateEcheancierPaiement({
          factureId: this.titreRecette.id,
          echeanciersPaiement: donneeForBack.echeanciers,
        });
        await updateFactureEnregistrer(donneeForBack.factureModifiee);
        await this.updateAttachments(donneeForBack.factureModifiee.id);
        messageSucces(this.$i18n.t('editionTitreRecette.messages.success.editFaturePayed'));
        await this.$router.push({
          name: 'c.gabed.titre_recette',
          params: {
            id: donneeForBack.factureModifiee.id,
          },
        });
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, this.messages, MODULE_TLPE, this.isAvoir);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          return;
        }
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    continuWithLigneWithoutDate() {
      this.popUpPrevention = false;
      this.continue = true;
      this.saveTitreRecette();
    },
    saveAnywayAndSaveTitreRecette() {
      this.saveAnyway = true;
      this.saveTitreRecette();
    },
    async generationEcheancierPaiementSauvegarde(titreRecette) {
      if (titreRecette.echeancierPaiement.length > 1
        || (titreRecette.echeancierPaiement.length === 1
          && titreRecette.montantTtc === this.montantTtcSave)) {
        return;
      }
      titreRecette.echeancierPaiement = (await echeancierGeneration({
        nombreEcheances: 1,
        datePremiereEcheance: this.datePaiement
          ? this.datePaiement : this.titreRecette.dateDevisCommande,
        periodicite: devisConf.MOIS,
        montantTotal: titreRecette.montantTtc
          - (titreRecette.montantAcomptesAffectes
            ? titreRecette.montantAcomptesAffectes : 0),
        modeReglementId: titreRecette.modeReglementId,
      })).data.result;
    },
    async saveTitreRecette() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        if (this.checkDateLignes) {
          loadingComponent.close();
          this.popUpPrevention = true;
          return;
        }
        await this.generationEcheancierPaiementSauvegarde(this.titreRecette);
        const copieTitreRecette = preparationEnvoiBack(this.titreRecette);
        copieTitreRecette.echeancierPaiement.forEach((element) => {
          element.dateEcheance = formatIsoDate(element.dateEcheance);
        });
        copieTitreRecette.rapprochements = this.getCommandeAchatARapprocher();
        let response = null;
        if (!this.$route.params.id) {
          copieTitreRecette.societeId = this.societeActiveId;
          response = (await create(copieTitreRecette)).data.result;
          await this.insertAttachments(response.id);
          messageSucces(this.$i18n.t('editionTitreRecette.messages.success.successCreation'));
        } else {
          response = (await update(copieTitreRecette)).data.result;
          await this.updateAttachments(response.id);
          messageSucces(this.$i18n.t('editionTitreRecette.messages.success.editQuotationSuccess'));
        }
        loadingComponent.close();
        await this.$router.push({ name: 'c.gabed.titre_recette', params: { id: response.id } });
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, this.messages, MODULE_TLPE, this.isAvoir);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        throw e;
      }
    },
    getCommandeAchatARapprocher() {
      const rapprochementGeneral = [];

      // si on a modifier des rapprochement on les mets a jour et on les pushs
      this.titreRecette.rapprochements.forEach((rapprochement) => {
        const rapprochementFind = this.commandeAchatARapprocher.find((commandeAchat) => {
          return commandeAchat.id === rapprochement.id;
        });
        if (rapprochementFind) {
          rapprochement.montant = rapprochementFind.montantAffecter;
          rapprochementGeneral.push({
            id: rapprochementFind.id,
            montant: rapprochementFind.montantAffecter,
          });
        }
      });

      // Si on ajoute des nouveaux rapprochement on les ajoutes
      this.commandeAchatARapprocher.forEach((commandeAchat) => {
        if (commandeAchat.montantAffecter !== 0
          && !this.titreRecette.rapprochements.find((rapprochement) => {
            return rapprochement.id === commandeAchat.id;
          })) {
          rapprochementGeneral.push({
            id: commandeAchat.id,
            montant: commandeAchat.montantAffecter,
          });
        }
      });

      return rapprochementGeneral;
    },
    async loadCommandeAchatRapprochement(tiersId) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let listeCommandeARapprocher = [];

        // recuperation des CA avec montant affecté
        listeCommandeARapprocher = this.commandeAchatARapprocher
          .filter((echeance) => {
            return echeance.montantAffecter !== 0;
          });
        listeCommandeARapprocher
          .forEach((commandeAchat) => {
            commandeAchat.isIntoActualSearch = false;
          });

        // get des CA avec filtre
        const query = cloneDeep(this.query);
        query.societeId = this.societeActiveId;
        query.module = MODULE_TLPE;
        if (query.codesDossier) {
          query.codes = query.codesDossier;
          delete query.codesDossier;
        }
        query.datesPremierAffichage.dateDebut = formatIsoDate(
          query.datesPremierAffichage.dateDebut,
        );
        query.datesPremierAffichage.dateFin = formatIsoDate(query.datesPremierAffichage.dateFin);
        query.tiersId = [tiersId];
        const newCommandesAchat = (await getAllEcheancier({
          query: query,
          limit: NO_PAGINATION,
        })).data.result.items;
        newCommandesAchat.forEach((echeance) => {
          echeance.montantAffecter = 0;
          echeance.isIntoActualSearch = true;
        });

        // Remise en place des CA précédement léttré + indicateur sur CA pour griser
        newCommandesAchat.forEach((newCommande) => {
          const commandeAlreadyExist = listeCommandeARapprocher.find((commandeSave) => {
            return commandeSave.id === newCommande.id;
          });
          if (!commandeAlreadyExist) listeCommandeARapprocher.push(newCommande);
          else commandeAlreadyExist.isIntoActualSearch = true;
        });
        sortCommandeAchat(listeCommandeARapprocher);
        this.commandeAchatARapprocher = listeCommandeARapprocher;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        throw e;
      }
    },
    addCommandeAchatDejaLettre(rapprochements) {
      const results = initializeCommandeAchatRapprochement(rapprochements, this.$route.params.id);
      const commandeARapprocher = this.commandeAchatARapprocher
        .filter((c) => !results.find((r) => r.id === c.id));
      results.push(...commandeARapprocher);
      this.commandeAchatARapprocher = results;
    },
    async resetCommandeArapprocher() {
      if (
        this.titreRecette.intervenants.length > 0
        && this.titreRecette.intervenants[0].tiersId !== null
        && !this.isAvoirLibre
      ) {
        this.commandeAchatARapprocher = [];
        await this.loadCommandeAchatRapprochement(this.titreRecette.intervenants[0].tiersId);
        messageSucces(this.$i18n.t('editionTitreRecette.messages.success.sucessReinitialisationRapprochement'));
      }
    },
    async updateCommandeArapprocher() {
      await this.loadCommandeAchatRapprochement(this.titreRecette.intervenants[0].tiersId);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'TitreRecette' });
      await this.loadParametres([PARAMETRES_KEYS.categorieGroupeProduitDeductible]);
      if (this.$route.params.id) {
        const response = (await get(this.$route.params.id)).data.result;
        this.active = 'factureInformation'; // à changer par rapprochement
        response.echeancierPaiement.sort();
        response.echeancierPaiement.forEach((el) => {
          el.dateEcheance = gestionDateBase(el.dateEcheance);
        });
        response.rapprochements.forEach((rapprochement) => {
          rapprochement.isIntoActualSearch = true;
          rapprochement.montantAffecter = 0;
        });
        response.lignesCommande.forEach((ligne) => { ligne.selected = false; });
        response.dateDevisCommande = moment(response.dateDevisCommande).toDate();
        await this.setAttachmentElementId({ id: response.id });
        await this.loadCommandeAchatRapprochement(response.intervenants[0].tiersId);
        this.addCommandeAchatDejaLettre(response.rapprochements);
        this.titreRecette = response;
      } else {
        let titreRecette = null;
        if (this.avoirACreer !== null) {
          titreRecette = cloneDeep(this.avoirACreer);
          this.setAvoirACreer(null);
        } else {
          titreRecette = genererDevisCommande(
            devisConf.TYPE_FACTURE,
            devisConf.NORMAL,
            this.societeActive,
            devisConf.SENS_ACHAT,
            devisConf.MODULE_TLPE,
          );
        }
        this.active = 'factureInformation';

        titreRecette.module = MODULE_TLPE;
        titreRecette.aRapprocher = true;
        titreRecette.etat = devisConf.ETAT_BROUILLON;
        titreRecette.escompte = false;
        titreRecette.penalite = false;
        titreRecette.rapprochements = [];
        titreRecette.avoirsAffectes = [];
        titreRecette.recouvrement = false;
        if (titreRecette.intervenants.length === 0) {
          const intervenant = genererIntervenant();
          intervenant.destinataire = true;
          intervenant.destinataireComptable = true;
          titreRecette.intervenants.push(intervenant);
        }
        if (this.agencesSelectionnees.length === 1) {
          titreRecette.agenceId = this.agencesSelectionnees[0].agenceId;
        }

        if (this.$route.name === 'm.gabed.titre_recette-save-to-edit-avoir') {
          titreRecette.referenceId = null;
          titreRecette.sousType = devisConf.SOUS_TYPE_AVOIR;
        }

        this.titreRecette = titreRecette;
      }

      if (!this.isBrouillon && this.$route.name === 'm.gabed.titre_recette-save-to-edit') {
        this.titreRecette.echeancierPaiement = await getInfoEcheancierPaiement(
          this.titreRecette.echeancierPaiement,
        );
        const detailTitreRecette = detailDevisCommande(this.titreRecette);
        detailTitreRecette.destinataireComptable.compteComptable = (
          await getTiers(detailTitreRecette.destinataireComptable.tiersId)
        ).data.result.compteComptable;
        this.titreRecetteDetail = detailTitreRecette;
        this.active = 'echeancierPaiement';
      }

      this.montantTtcSave = this.titreRecette.montantTtc;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
    if (this.$route.params.id) {
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.titreRecette.code }));
    } else {
      this.setInformationPage(this.$t('pagePatrimoine.titreRecette.creation'));
    }
  },
};
</script>

<style>

</style>
